<script type="text/ecmascript-6">
import ElDatePicker from 'element-ui/lib/date-picker'

export default {
  name: 'UniDateRangePicker',
  data() {
    return {
      // 默认快捷选项
      defaultPickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        },
        shortcuts: [
          {
            text: '今天',
            onClick(picker) {
              const end = new Date()
              const start = new Date(new Date().setHours(0, 0, 0, 0)) // 获取当天零点的时间
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近三天',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 3)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }]
      }
    }
  },
  mixins: [
    ElDatePicker
  ],
  mounted() {
    // 设置默认快捷选项
    this.pickerOptions = this.defaultPickerOptions
    // 由于mountPicker方法在ElDatePicker组件的created方法调用，因此只能重新加载组件
    this.unmountPicker()
    this.mountPicker()
  },
  methods: {
  }
}
</script>

<style lang="scss">
  // @import "UniDateRangePicker.scss";
</style>



// WEBPACK FOOTER //
// src/components/uniWidgets/UniDateRangePicker/UniDateRangePicker.vue